export const untitledStatechart = "Untitled Statechart";

export function validateStatechartName(value: string): string {
  value = value.replace(/[^\w\d\s_-]+/g, "").trim();
  if (value === "") {
    value = untitledStatechart;
  }
  return value;
}
